export default __webpack_public_path__ + "static/media/corporate-masthead-mob.4bac284d.png";